export default "__VITE_ASSET__BF7DKor3__"